// extracted by mini-css-extract-plugin
export default {"link":"piWbme5Sx_y78a4T6sw3","errorText":"SCFEyOQU4oD0dBxevech","hideMobile":"XctWALkcfN0l6Zwjrbzm","text":"LchVwYqTXUwAdlkqzhHp"};